// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ek-a";
export var fulfillmentFormRail = "_ek-9";
export var headerTitleRow = "_ek-c";
export var orderDetailsWrapper = "_ek-7";
export var orderLinkTrigger = "_ek-2";
export var paymentInformationGrid = "_ek-h";
export var paymentSummaryColumn = "_ek-i";
export var shipmentContainer = "_ek-b";
export var shipmentDetailsMainPane = "_ek-8";
export var shipmentNavigationCard = "_ek-5";
export var shipmentNavigationRail = "_ek-3";
export var shipmentNavigationRailHeader = "_ek-4";
export var shipmentSummaryFact = "_ek-e";
export var shipmentSummaryGrid = "_ek-d";
export var shipmentSummaryMetadataRow = "_ek-f";
export var shipmentSummaryTags = "_ek-g";
export var shipmentWorkspace = "_ek-0";
export var shipmentWorkspaceContent = "_ek-6";
export var shipmentWorkspaceHeader = "_ek-1";